<!--
  src/components/DialogLinkTasksToCourse.vue
  Bulk-links the selected bank tasks to a course the admin picks.
  Stage 1 of the tasks flow: POST api/Admin/TasksBank/CourseTasks { tasksBankId, courseId }
  is called once per selected task (idempotent server-side, so re-linking is safe).
-->
<template>
  <div class="DialogLinkTasksToCourse__Component" dir="rtl">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">שיוך משימות לקורס</p>
        <button type="button" class="delete" @click="$emit('close')" />
      </header>
      <section class="modal-card-body">
        <p class="DialogLinkTasksToCourse__Count">
          נבחרו <b>{{ tasks.length }}</b> משימות לשיוך.
        </p>
        <b-field label="קורס:">
          <FieldInlineSelect
            label="קורס"
            :filterable="true"
            :clearable="true"
            :optionsAsync="getCourses"
            v-model="courseId"
          />
        </b-field>
        <div class="DialogLinkTasksToCourse__Note">
          המשימות ישויכו לקורס שנבחר. שיוך חוזר של משימה שכבר משויכת אינו יוצר כפילות.
        </div>
      </section>
      <footer class="modal-card-foot">
        <b-button
          :loading="isLoading"
          :disabled="!courseId"
          label="שייך"
          type="is-primary"
          @click="save"
        />
        <b-button :disabled="isLoading" label="סגור" @click="$emit('close')" />
      </footer>
    </div>
  </div>
</template>

<script>
import FieldInlineSelect from "@/components/Fields/FieldInlineSelect.vue";
import CoursesService from "@/services/CoursesService";
import TasksService from "@/services/TasksService";

export default {
  name: "DialogLinkTasksToCourse",
  components: { FieldInlineSelect },
  props: {
    tasks: { type: Array, default: () => [] },
    onSuccess: { type: Function, default: null },
  },
  data() {
    return {
      isLoading: false,
      courseId: null,
    };
  },
  methods: {
    getCourses() {
      return () =>
        CoursesService.getCourses(true).then((r) =>
          r.data.map((i) => ({ Value: i.id, Text: `${i.id} - ${i.name}` }))
        );
    },
    save() {
      if (!this.courseId || !this.tasks.length) return;
      this.isLoading = true;
      Promise.all(
        this.tasks.map((t) =>
          TasksService.linkTaskToCourse({ TasksBankId: t.id, CourseId: this.courseId })
        )
      )
        .then(() => {
          this.$buefy.toast.open({
            type: "is-success",
            message: `${this.tasks.length} משימות שויכו לקורס בהצלחה!`,
            duration: 4000,
          });
          if (this.onSuccess) this.onSuccess();
          this.$emit("close");
        })
        .catch((e) => {
          const msg = e && e.response && e.response.data && e.response.data.Error;
          this.$buefy.toast.open({
            type: "is-danger",
            message: msg || "השיוך נכשל!",
            duration: 4000,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style scoped lang="scss">
.DialogLinkTasksToCourse__Count {
  margin-bottom: 12px;
}
.DialogLinkTasksToCourse__Note {
  margin-top: 20px;
  font-size: 13px;
  color: #6b7b8c;
}
</style>
